// User actions API functions
// This file contains user-related API functions
import {
  addDoc,
  collection,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { getFirebaseDb } from "@/lib/api/firebase-ultra-safe";

export interface UserAction {
  id: string;
  userId: string;
  action: string;
  timestamp: Date;
  metadata?: Record<string, unknown>;
}

export const createUserAction = async (action: UserAction): Promise<void> => {
  // Implementation for creating user actions
  console.log("Creating user action:", action);
};

export const getUserActions = async (userId: string): Promise<UserAction[]> => {
  // Implementation for getting user actions
  console.log("Getting user actions for user:", userId);
  return [];
};

export const deleteUserAction = async (actionId: string): Promise<void> => {
  // Implementation for deleting user actions
  console.log("Deleting user action:", actionId);
};

export const logAuthAction = async (
  userId: string,
  action: string,
  metadata?: Record<string, unknown>
): Promise<void> => {
  try {
    const db = await getFirebaseDb();
    if (!db) return;

    const safeMetadata = Object.fromEntries(
      Object.entries(metadata || {}).filter(([, value]) => value !== undefined)
    );
    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 90);

    await addDoc(collection(db, "authLogs"), {
      userId,
      action,
      metadata: safeMetadata,
      createdAt: serverTimestamp(),
      expiresAt: Timestamp.fromDate(expiresAt),
    });
  } catch (error) {
    // 로그 실패가 로그인 자체를 막으면 안 됩니다.
    console.warn("인증 로그 저장 실패:", error);
  }
};
